import { overrideOptional } from '@emico-utils/overrides'
import { SVGProps } from 'react'

import { ChevronBaseIcon, ChevronDirection } from './ChevronBaseIcon'

export const ChevronRightIcon = overrideOptional(
  (props: SVGProps<SVGSVGElement>) => (
    <ChevronBaseIcon groupTransform={ChevronDirection.right} {...props} />
  ),
)
